import { render } from "./BackToTheTopButton.vue?vue&type=template&id=45878f24"
import script from "./BackToTheTopButton.vue?vue&type=script&lang=js"
export * from "./BackToTheTopButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__